import { apiHeaders } from '../../utils/utils'
import axiosWrapper from '../helpers/api'
import { ERequestUrl, EMethods } from '../helpers/requests'
import { LOCAL_STORAGE_KEYS } from '@/utils/constants'

export const postProductToReturn = (data) => {
  const token = localStorage?.getItem(LOCAL_STORAGE_KEYS.TOKEN)
  const headers = token
    ? apiHeaders(localStorage.getItem(LOCAL_STORAGE_KEYS.CONNEXION_TYPE))
    : {}
  return axiosWrapper({
    method: EMethods.post,
    url: ERequestUrl.return,
    data: data,
    headers,
  })
}

export const getOrderInvoice = (orderToken: number) =>
  axiosWrapper({
    method: EMethods.get,
    url: ERequestUrl.invoice,
    uid: orderToken + '/invoice/download',
  })
